export function getCompassDirection(dx, dy) {
    if (dx === 0 && dy === 0)
        return null;
    const octant = Math.round(Math.atan2(dy, dx) / (Math.PI / 4));
    switch (octant) {
        case 0: return 'east';
        case 1: return 'southeast';
        case 2: return 'south';
        case 3: return 'southwest';
        case 4:
        case -4: return 'west';
        case -3: return 'northwest';
        case -2: return 'north';
        case -1: return 'northeast';
        default: return 'south';
    }
}
